export default "__VITE_ASSET__uqbj0e7wxBJ7xARkGbVuFQ__"